__turbopack_context__.v({
  "compareDivider": "hairColorChanger-module__coCEwG__compareDivider",
  "compareHandle": "hairColorChanger-module__coCEwG__compareHandle",
  "compareImg": "hairColorChanger-module__coCEwG__compareImg",
  "comparePill": "hairColorChanger-module__coCEwG__comparePill",
  "comparePillLeft": "hairColorChanger-module__coCEwG__comparePillLeft",
  "comparePillRight": "hairColorChanger-module__coCEwG__comparePillRight",
  "compareRange": "hairColorChanger-module__coCEwG__compareRange",
  "compareSlider": "hairColorChanger-module__coCEwG__compareSlider",
  "compareSliderFill": "hairColorChanger-module__coCEwG__compareSliderFill",
  "crossLinkCopy": "hairColorChanger-module__coCEwG__crossLinkCopy",
  "demoCaption": "hairColorChanger-module__coCEwG__demoCaption",
  "demoChip": "hairColorChanger-module__coCEwG__demoChip",
  "demoChipActive": "hairColorChanger-module__coCEwG__demoChipActive",
  "demoChipCircle": "hairColorChanger-module__coCEwG__demoChipCircle",
  "demoChipName": "hairColorChanger-module__coCEwG__demoChipName",
  "demoChipRow": "hairColorChanger-module__coCEwG__demoChipRow",
  "demoGrid": "hairColorChanger-module__coCEwG__demoGrid",
  "demoIntro": "hairColorChanger-module__coCEwG__demoIntro",
  "demoSection": "hairColorChanger-module__coCEwG__demoSection",
  "dropzone": "hairColorChanger-module__coCEwG__dropzone",
  "emptyToolGrid": "hairColorChanger-module__coCEwG__emptyToolGrid",
  "expectCard": "hairColorChanger-module__coCEwG__expectCard",
  "familyChip": "hairColorChanger-module__coCEwG__familyChip",
  "familyChipCircle": "hairColorChanger-module__coCEwG__familyChipCircle",
  "familyPill": "hairColorChanger-module__coCEwG__familyPill",
  "familyPillActive": "hairColorChanger-module__coCEwG__familyPillActive",
  "familyPillRow": "hairColorChanger-module__coCEwG__familyPillRow",
  "familySection": "hairColorChanger-module__coCEwG__familySection",
  "familySectionChips": "hairColorChanger-module__coCEwG__familySectionChips",
  "familySectionCopy": "hairColorChanger-module__coCEwG__familySectionCopy",
  "familySectionTitle": "hairColorChanger-module__coCEwG__familySectionTitle",
  "faqAnswer": "hairColorChanger-module__coCEwG__faqAnswer",
  "faqCard": "hairColorChanger-module__coCEwG__faqCard",
  "faqQuestion": "hairColorChanger-module__coCEwG__faqQuestion",
  "folio": "hairColorChanger-module__coCEwG__folio",
  "folioTitle": "hairColorChanger-module__coCEwG__folioTitle",
  "hero": "hairColorChanger-module__coCEwG__hero",
  "heroEyebrow": "hairColorChanger-module__coCEwG__heroEyebrow",
  "heroSubtitle": "hairColorChanger-module__coCEwG__heroSubtitle",
  "heroTitle": "hairColorChanger-module__coCEwG__heroTitle",
  "heroTrust": "hairColorChanger-module__coCEwG__heroTrust",
  "historyMicrocopy": "hairColorChanger-module__coCEwG__historyMicrocopy",
  "historyStrip": "hairColorChanger-module__coCEwG__historyStrip",
  "historyThumb": "hairColorChanger-module__coCEwG__historyThumb",
  "historyThumbActive": "hairColorChanger-module__coCEwG__historyThumbActive",
  "historyThumbImg": "hairColorChanger-module__coCEwG__historyThumbImg",
  "historyThumbLabel": "hairColorChanger-module__coCEwG__historyThumbLabel",
  "mobileUpload": "hairColorChanger-module__coCEwG__mobileUpload",
  "photoColumn": "hairColorChanger-module__coCEwG__photoColumn",
  "photoFrame": "hairColorChanger-module__coCEwG__photoFrame",
  "photoImg": "hairColorChanger-module__coCEwG__photoImg",
  "pickerColumn": "hairColorChanger-module__coCEwG__pickerColumn",
  "pickerFooter": "hairColorChanger-module__coCEwG__pickerFooter",
  "privacyMicrocopy": "hairColorChanger-module__coCEwG__privacyMicrocopy",
  "progressBarFill": "hairColorChanger-module__coCEwG__progressBarFill",
  "progressBarFillFast": "hairColorChanger-module__coCEwG__progressBarFillFast",
  "progressBarFillSlow": "hairColorChanger-module__coCEwG__progressBarFillSlow",
  "progressBarTrack": "hairColorChanger-module__coCEwG__progressBarTrack",
  "progressCopy": "hairColorChanger-module__coCEwG__progressCopy",
  "progressCreepFast": "hairColorChanger-module__coCEwG__progressCreepFast",
  "progressCreepSlow": "hairColorChanger-module__coCEwG__progressCreepSlow",
  "progressIcon": "hairColorChanger-module__coCEwG__progressIcon",
  "progressModule": "hairColorChanger-module__coCEwG__progressModule",
  "progressOverlay": "hairColorChanger-module__coCEwG__progressOverlay",
  "progressStageLabel": "hairColorChanger-module__coCEwG__progressStageLabel",
  "progressTip": "hairColorChanger-module__coCEwG__progressTip",
  "sectionTitle": "hairColorChanger-module__coCEwG__sectionTitle",
  "selectedShadeCard": "hairColorChanger-module__coCEwG__selectedShadeCard",
  "selectedShadeCircle": "hairColorChanger-module__coCEwG__selectedShadeCircle",
  "stepCard": "hairColorChanger-module__coCEwG__stepCard",
  "stepNumber": "hairColorChanger-module__coCEwG__stepNumber",
  "stickyActionBar": "hairColorChanger-module__coCEwG__stickyActionBar",
  "stickyShadeCircle": "hairColorChanger-module__coCEwG__stickyShadeCircle",
  "studioSwatch": "hairColorChanger-module__coCEwG__studioSwatch",
  "studioSwatchLabel": "hairColorChanger-module__coCEwG__studioSwatchLabel",
  "swatch": "hairColorChanger-module__coCEwG__swatch",
  "swatchCircle": "hairColorChanger-module__coCEwG__swatchCircle",
  "swatchName": "hairColorChanger-module__coCEwG__swatchName",
  "swatchPanel": "hairColorChanger-module__coCEwG__swatchPanel",
  "swatchSelected": "hairColorChanger-module__coCEwG__swatchSelected",
  "teaserLockBadge": "hairColorChanger-module__coCEwG__teaserLockBadge",
  "teaserTile": "hairColorChanger-module__coCEwG__teaserTile",
  "teaserTileImg": "hairColorChanger-module__coCEwG__teaserTileImg",
  "teaserTileLabel": "hairColorChanger-module__coCEwG__teaserTileLabel",
  "teaserTileSwatch": "hairColorChanger-module__coCEwG__teaserTileSwatch",
  "threeStepArrow": "hairColorChanger-module__coCEwG__threeStepArrow",
  "threeStepItem": "hairColorChanger-module__coCEwG__threeStepItem",
  "threeStepStrip": "hairColorChanger-module__coCEwG__threeStepStrip",
  "toolCard": "hairColorChanger-module__coCEwG__toolCard",
  "toolGrid": "hairColorChanger-module__coCEwG__toolGrid",
  "uploadButton": "hairColorChanger-module__coCEwG__uploadButton",
  "uploadStage": "hairColorChanger-module__coCEwG__uploadStage",
  "upsellBenefitGrid": "hairColorChanger-module__coCEwG__upsellBenefitGrid",
  "upsellBenefitIcon": "hairColorChanger-module__coCEwG__upsellBenefitIcon",
  "upsellBenefitItem": "hairColorChanger-module__coCEwG__upsellBenefitItem",
  "upsellCard": "hairColorChanger-module__coCEwG__upsellCard",
  "upsellModalCopy": "hairColorChanger-module__coCEwG__upsellModalCopy",
  "upsellModalHeadline": "hairColorChanger-module__coCEwG__upsellModalHeadline",
  "upsellModalReassurance": "hairColorChanger-module__coCEwG__upsellModalReassurance",
  "upsellSub": "hairColorChanger-module__coCEwG__upsellSub",
  "upsellTitle": "hairColorChanger-module__coCEwG__upsellTitle",
  "upsellValueLine": "hairColorChanger-module__coCEwG__upsellValueLine",
});
